import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../components/react/Dropdown';

const NewsFeedHeader = ({
  title,
  typeLabel,
  typeOptions,
  typeValue,
  onTypeChange,
  yearLabel,
  yearOptions,
  yearValue,
  onYearChange
}) => (
  <div className="news-feed__header">
    <h2 className="news-feed__title">{title}</h2>
    <div className="news-feed__filters">
      {!!typeOptions && (
        <div className="news-feed__type-filter">
          <Dropdown
            style="small"
            label={typeLabel}
            selectedOption={
              typeValue
                ? typeOptions.find(opt => opt.value === typeValue)
                : typeOptions[0]
            }
            options={typeOptions}
            onChange={type => onTypeChange(type.value)}
          />
        </div>
      )}
      {!!yearOptions && (
        <div className="news-feed__year">
          <Dropdown
            style="small"
            label={yearLabel}
            selectedOption={
              yearOptions.find(opt => opt.value === yearValue) ||
              yearOptions.find(
                opt => parseInt(opt.value) === new Date().getFullYear()
              ) ||
              yearOptions[0]
            }
            options={yearOptions}
            onChange={year => onYearChange(year.value)}
          />
        </div>
      )}
    </div>
  </div>
);

NewsFeedHeader.propTypes = {
  title: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  typeOptions: PropTypes.array,
  typeValue: PropTypes.string,
  onTypeChange: PropTypes.func.isRequired,
  yearLabel: PropTypes.string.isRequired,
  yearOptions: PropTypes.array,
  yearValue: PropTypes.string,
  onYearChange: PropTypes.func.isRequired
};

export default NewsFeedHeader;
